import { Leaf, Wheat, Sparkles, Wine } from "lucide-react";
import { useLang } from "../context/LanguageContext";

export function DietTags({ tags = [] }) {
  const { lang } = useLang();
  if (!tags || tags.length === 0) return null;
  const es = lang === "es";
  const map = {
    gf:   { label: "GF",  labelEs: "SG",  cls: "bg-amber-100 text-amber-800 border-amber-200",     icon: Wheat,    title: es ? "Sin Gluten" : "Gluten Free" },
    v:    { label: "V",   labelEs: "V",   cls: "bg-emerald-100 text-emerald-800 border-emerald-200", icon: Leaf,    title: es ? "Vegetariano" : "Vegetarian" },
    vg:   { label: "VG",  labelEs: "VG",  cls: "bg-lime-100 text-lime-800 border-lime-200",         icon: Leaf,    title: es ? "Vegano" : "Vegan" },
    star: { label: "Signature", labelEs: "Estrella", cls: "bg-brand/10 text-brand border-brand/30", icon: Sparkles, title: es ? "Estrella de la casa" : "Chef's Signature" },
    alc:  { label: "21+", labelEs: "21+", cls: "bg-rose-100 text-rose-800 border-rose-200",         icon: Wine,     title: es ? "Bebida alcohólica" : "Alcoholic beverage" },
  };
  return (
    <div className="flex items-center gap-1.5 flex-wrap">
      {tags.map((t) => {
        const m = map[t];
        if (!m) return null;
        const Icon = m.icon;
        return (
          <span
            key={t}
            title={m.title}
            className={`inline-flex items-center gap-1 px-2 py-0.5 rounded-full text-[10px] font-semibold uppercase tracking-wider border ${m.cls}`}
          >
            <Icon className="w-3 h-3" />
            {es ? m.labelEs : m.label}
          </span>
        );
      })}
    </div>
  );
}
